import { provinces } from '@bcba/types';
import {
  DigitalDossierDocumentSerializer,
  DigitalDossierTaxInformationSerializer,
} from '@bcba/serializers';
import { CompanyTaxInformationDocument } from '@bcba/db';

export const jurisdictionOptions = provinces.map((province) => ({
  value: province,
  label: province
    .toLocaleLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' '),
}));

export const explorerBaseDefaultAdditionalDocumentForTaxInfo = {
  file: {
    s3TempKey: '',
    name: '',
    mimeType: '',
  },
};

export const mapTaxInfoSerializerToDTO = (
  apiResponse: DigitalDossierTaxInformationSerializer,
) => {
  const mapDocument = (
    doc?: DigitalDossierDocumentSerializer<CompanyTaxInformationDocument>,
  ) =>
    doc
      ? {
          uuid: doc.uuid || '',
          documentUuid: doc?.document?.uuid,
          keepOriginal: true,
          originalName: doc.document?.originalFileName || '',
          identifier: doc.document?.identifier || '',
          expirationDate: doc.document?.expirationDate || '',
        }
      : explorerBaseDefaultAdditionalDocumentForTaxInfo;

  const dto = {
    cuitDocument: mapDocument(apiResponse.cuitDocument),
    ivaCondition: apiResponse.ivaCondition || '',
    bruteIncome: apiResponse.bruteIncomeId || '',
    jurisdictions:
      apiResponse.jurisdictions?.map(
        (jurisdiction) => jurisdiction.province?.key || '',
      ) || [],
    iibbDocument: mapDocument(apiResponse.iibbDocument),
    profits: apiResponse.profitsId || '',
    profitsDocument: mapDocument(apiResponse.profitsDocument),
    cm05Document: mapDocument(apiResponse.cm05Document),
    exemptionsDocument: mapDocument(apiResponse.exemptionsDocument),
    additionalDocuments:
      apiResponse.additionalDocuments?.map(mapDocument) || [],
  };

  return dto;
};
